<script>
import { mapActions } from "vuex";

import BaseListView from "../../../base/BaseListView.vue";
import TaxRateModal from "./TaxRateModal.vue";

import BaseUserDialogSelector from "@/components/shared/BaseDialogSelectors/BaseUserDialogSelector.vue";

export default {
  extends: BaseListView,
  components: { 
    TaxRateModal,
    BaseUserDialogSelector,
  },
  page: {
    title: "Tax Rates",
  },
  data() {
    return {
      fields: [
        { key: "name", sortable: true },
        { key: "percentage", sortable: true },
        // { key: "threshold", sortable: true },
        "edit",
        "archive",
      ],
      tax_rates: {},
      selectedRow: null,
      modelName: { singular: "Tax Rate", plural: "Tax Rates" },

      tax_groups: {},
      tax_group_fields: ["name", "edit"],
    };
  },
  methods: {
    ...mapActions("taxRates", ["fetchTaxRates", "archiveTaxRate"]),
    ...mapActions("taxGroups", ["fetchTaxGroups", "archiveTaxGroup"]),
    ...mapActions("application", ["setIsTableLoading"]),

    openModal() {
      this.selectedRow = null;
      setTimeout(() => {
        this.$refs.modal.show();
      }, 100);
    },

    async archive(id, value) {
      try {
        await this.archiveTaxRate({
          id: id,
          archive: value,
          organisation: this.getCurrentOrganisation.id,
        });
        this.query();
      } catch {}
    },

    edit(id) {
      this.selectedRow = id;
      setTimeout(() => {
        this.$refs.modal.show();
      }, 100);
    },

    query() {
      this.setIsTableLoading(true);
      this.fetchTaxRates({
        organisation: this.getCurrentOrganisation.id,
        ...this.query_params,
      }).then((res) => {
        this.tax_rates = res.data;
      }).catch((error) => {
      }).finally(() => {
        this.setIsTableLoading(false);
      });
    },

    new_tax_group() {
      this.$router.push(`/settings/taxes/tax_group/edit/`);
    },

    edit_tax_group(id) {
      this.$router.push({
        name: "Edit Tax Group",
        params: { id },
      });
    },

    query_tax_group(page, page_size, search_query) {
      this.query_params.page = page;
      this.query_params.page_size = page_size;
      this.query_params.search = search_query;

      this.fetchTaxGroups({
        organisation: this.getCurrentOrganisation.id,
        ...this.query_params,
      }).then((res) => {
        this.tax_groups = res.data;
      }).catch((error) => {});
    },
  },
  mounted() {
    this.query();

    this.fetchTaxGroups({
      organisation: this.getCurrentOrganisation.id,
      ...this.query_params,
    }).then((res) => {
      this.tax_groups = res.data;
    }).catch((error) => {});
  },
};
</script>

<template>
  <div>
    <PageHeader
      :modelName="modelName"
      @create="openModal()"
      v-model="query_params.search"
    >
      <template v-slot:filters>
        <base-toggle-button-group id="archived" label="Archived" variant="primary" v-model="query_params.archived" :options="archived_options"/>
        <BaseUserDialogSelector label="Created By" v-model="query_params.created_by" />
        <BaseUserDialogSelector label="Edited By" v-model="query_params.edited_by" />
      </template>
    </PageHeader>

    <TaxRateModal ref="modal" :id="selectedRow" @upserted="query" />

    <base-card>
      <base-table
        ref="table"
        :data_="tax_rates"
        :fields="fields"
        :modelName="modelName"
        @archive="archive"
        @edit="edit"
        @page_change="query_params.page = $event"
        @page_size_change="query_params.page_size = $event"
        @ordering_change="query_params.ordering = $event"
      />
    </base-card>

    <!-- We're hiding Tax Groups for now - as they are only necessary in the U.S -->
    <!--
        <base-card>
          <base-table ref="table" title="Tax Groups" :data_="tax_groups" :fields="tax_group_fields" :showRowsPerPage="false" @query="query_tax_group" @open-modal="new_tax_group"
            @edit="edit_tax_group" />
        </base-card> -->
  </div>
</template>
